import { Button, CircularProgress } from "@material-ui/core";
import NotificationPopup from "../../common/NotificationPopup";
import {getAccessToken, useUser} from "../../Auth";
import { useState } from "react";
import {useCreateLogMutation} from "../../generated/graphql";

const uploadFile = async (uriPart: string, files: File[], onSuccess) => {
    const token = await getAccessToken();
    const formData = new FormData();
    files.forEach(file=>
    {
        formData.append("files", file,file.name);
    });
    const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URI}${uriPart}`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        }
    );
    if (res.ok) {
        NotificationPopup.success(`上傳成功`);
        res.json().then((res) => {
            onSuccess(res);
        })
    } else {
        res.json().then((res) => NotificationPopup.error(`上傳遇到問題. ${res?.message}`)).catch(()=>NotificationPopup.error(`上傳遇到問題.`));
        console.error(
            `failed to upload file. statustext: ${res.statusText} status: ${res.status}`
        );
    }
};

export default ({  onSuccess, uriPart, uploadTitle,
                    entityId="0", queryAction='', queryEntity='', queryMessage=''}) => {
    const [files, setFiles] = useState<File[]>([]);
    const [loading, setLoading] = useState(false);
    const user = useUser();
    const [createLog] = useCreateLogMutation();

    return (
        <div>
            {!loading && (
                <Button
                    variant={"contained"}
                    color={"primary"}
                    component={"label"}
                    htmlFor={uriPart}
                >
                    {uploadTitle}
                </Button>
            )}
            {loading && <CircularProgress />}
            <br />
            {files.length>0 && (
                <div>
                    {files.map(file=><p>已選擇檔案: {file.name}</p>)}
                    <Button
                        variant={"contained"}
                        color={"primary"}
                        onClick={async () => {
                            setLoading(true);
                            await uploadFile(uriPart, files, onSuccess);
                            setLoading(false);
                            setFiles([]);
                            await createLog({
                                variables: {
                                    log: {
                                        entityId: entityId,
                                        userId: user!.id as string,
                                        queryAction: uploadTitle,
                                        queryEntity: queryEntity,
                                        queryMessage: queryMessage,
                                    }
                                }
                            });
                        }}
                    >
                        上傳
                    </Button>
                </div>
            )}

            <input
                style={{ display: "none" }}
                id={uriPart}
                type={"file"}
                multiple={true}
                onChange={(e) => {
                    const files = e.target.files;
                    const fileList:File[] = [];
                    for(let i = 0;i < (files?.length || 0);i++)
                    {
                        if(files && files[i])
                        {
                            fileList.push(files[i]);
                        }
                    }
                    setFiles(fileList);
                }}
            />
        </div>
    );
};
